import { useEffect } from "react";
import { useMap } from "react-leaflet";
import L from "leaflet";

const AMERICA_BOUNDS = L.latLngBounds(
  [24.396308, -125.0],
  [49.384358, -66.93457]
);

export const FitBoundsSingle = (location) => {
  const map = useMap();
  useEffect(() => {
    if (!!location.latitude && !!location.longitude) {
      const bounds = L?.latLngBounds(
        [[location.latitude, location.longitude]]
      );
      map?.fitBounds(bounds, { padding: [50, 50] });
    } else {
      map?.fitBounds(AMERICA_BOUNDS, { padding: [50, 50] });
    }
  }, [location, map]);
  
  return null;
};
